export default {
  'menu.welcome': 'Welcome',
  'menu.more-blocks': 'More Blocks',
  'menu.home': 'Home',
  'menu.admin': 'Admin',
  'menu.admin.sub-page': 'Sub-Page',
  // Dashboard
  'menu.admin.dashboard': 'Dashboard',
  // User Management
  'menu.admin.user-list': 'User List',
  'menu.admin.kyc': 'KYC Management',
  'menu.admin.user-detail': 'User Detail',
  'menu.admin.user-keys': 'API Key Management',
  // VCC Management
  'menu.admin.vcc-products': 'Products',
  'menu.admin.vcc-applications': 'Applications',
  'menu.admin.vcc-cards': 'Cards',
  // Wallet Management
  'menu.admin.wallet-records': 'Transaction Records',
  'menu.admin.wallet-history': 'History',
  'menu.admin.withdraw-config': 'Withdraw Config',
  // Swap Management
  'menu.admin.swap-manage': 'Swap Config',
  'menu.admin.swap-orders': 'Swap Orders',
  // Distribution Management
  'menu.admin.commission': 'Commission',
  // System Management
  'menu.admin.roles': 'Roles',
  'menu.admin.operation-logs': 'Operation Logs',
  // Legacy menu (for compatibility)
  'menu.admin.user-manage': 'User Management',
  'menu.admin.role-manage': 'Roles & Permissions',
  'menu.admin.kyc-manage': 'KYC Management',
  'menu.admin.card-manage': 'Card Management',
  'menu.admin.card-application': 'Card Applications',
  'menu.admin.user-cards': 'User Cards',
  'menu.admin.commission-manage': 'Commission Management',
  'menu.login': 'Login',
  'menu.dashboard': 'Dashboard',
  'menu.dashboard.analysis': 'Analysis',
  'menu.dashboard.monitor': 'Monitor',
  'menu.dashboard.workplace': 'Workplace',
  'menu.exception.403': '403',
  'menu.exception.404': '404',
  'menu.exception.500': '500',
  'menu.form': 'Form',
  'menu.form.basic-form': 'Basic Form',
  'menu.form.step-form': 'Step Form',
  'menu.form.step-form.info': 'Step Form(write transfer information)',
  'menu.form.step-form.confirm': 'Step Form(confirm transfer information)',
  'menu.form.step-form.result': 'Step Form(finished)',
  'menu.form.advanced-form': 'Advanced Form',
  'menu.list': 'List',
  'menu.list.table-list': 'Search Table',
  'menu.list.basic-list': 'Basic List',
  'menu.list.card-list': 'Card List',
  'menu.list.search-list': 'Search List',
  'menu.list.search-list.articles': 'Search List(articles)',
  'menu.list.search-list.projects': 'Search List(projects)',
  'menu.list.search-list.applications': 'Search List(applications)',
  'menu.profile': 'Profile',
  'menu.profile.basic': 'Basic Profile',
  'menu.profile.advanced': 'Advanced Profile',
  'menu.result': 'Result',
  'menu.result.success': 'Success',
  'menu.result.fail': 'Fail',
  'menu.exception': 'Exception',
  'menu.exception.not-permission': '403',
  'menu.exception.not-find': '404',
  'menu.exception.server-error': '500',
  'menu.exception.trigger': 'Trigger',
  'menu.wallet': 'Wallet',
  'menu.wallet.records': 'Transaction Records',
  'menu.wallet.history': 'History',
  'menu.account': 'Account',
  'menu.account.center': 'Referral Center',
  'menu.account.settings': 'Account Settings',
  'menu.account.card-center': 'Card Center',
  'menu.account.assets': 'My Assets',
  'menu.account.my-cards': 'Card Application',
  'menu.account.user-cards': 'My Cards',
  'menu.account.trigger': 'Trigger Error',
  'menu.account.logout': 'Logout',
  'menu.account.lang': 'Language',
  'menu.account.theme': 'Appearance',
  'menu.account.theme.light': 'Light',
  'menu.account.theme.dark': 'Dark',
  'menu.account.theme.system': 'System',
  'menu.editor': 'Graphic Editor',
  'menu.editor.flow': 'Flow Editor',
  'menu.editor.mind': 'Mind Editor',
  'menu.editor.koni': 'Koni Editor',
  // Menu groups: User Center / Model Integration / Studio / Content Ops / Operations Monitor / Settings
  'menu.users-center': 'User Center',
  'menu.users-center.users': 'Users',
  'menu.users-center.teams': 'Teams',
  'menu.users-center.orders': 'Orders',
  'menu.users-center.ledger': 'Spending',
  'menu.users-center.assets': 'User Assets',
  // Model Integration — providers / models / billing
  'menu.resources': 'Model Integration',
  'menu.resources.providers': 'Providers',
  'menu.resources.route-models': 'Model Display & Routing',
  'menu.resources.routes': 'Caller Routes',
  'menu.resources.pricing': 'Pricing & Cost',
  // Legacy keys kept for back-compat redirects only
  'menu.resources.catalog': 'Models',
  'menu.resources.models': 'Models',
  'menu.resources.llm-routes': 'LLM Caller Routes',
  'menu.resources.image-routes': 'Image Caller Routes',
  // Studio — global config for AI creation
  'menu.studio': 'Studio',
  'menu.studio.prompts': 'Prompt Templates',
  'menu.studio.skills': 'Skill Library',
  'menu.studio.skill-market': 'Skill Marketplace',
  // Content Ops — marketplace moderation + outreach + analytics
  'menu.content': 'Content Ops',
  'menu.content.publications': 'Publications',
  'menu.content.reports': 'Reports',
  'menu.content.popups': 'Popups',
  'menu.content.analytics': 'Analytics',
  // Operations Monitor — observability only
  'menu.monitor': 'Operations Monitor',
  'menu.monitor.system': 'System Monitor',
  'menu.monitor.tasks': 'Tasks',
  'menu.monitor.access': 'Access Logs',
  'menu.monitor.costs': 'Cost Records',
  'menu.monitor.alerts': 'Alerts',
  // Settings — platform config + broadcast
  'menu.settings': 'Settings',
  'menu.settings.system': 'System Settings',
  'menu.settings.announcements': 'Announcements',
  // legacy keys (kept for any leftover references)
  'menu.global': 'Global Management',
  'menu.global.users': 'User Management',
  // AI single image generation
  'menu.image': 'AI Image',
  'menu.image.generate': 'Single Image',
  // Drama Studio
  'menu.drama': 'Drama Studio',
  'menu.drama.projects': 'Projects',
  'menu.drama.prompt-templates': 'Prompt Templates',
};
